import React from "react";

export default function QuestionDisplay({ question, onAnswerClick }){
    if (!question){
        return <div>Question not found.</div>;
    }

    const hasImage = question.answers.some(answer => !!answer.image);

    return (
        <div className="questions">            
            <div className="questions-label h3">{question.text}</div>
            <div className={`questions-answer-list ${`answer-count-${question.answers.length}`}${hasImage ? " has-image" : ""}`}>
                {question.answers.map((answer) => (
                    <div key={answer.answerId}>
                        {answer.image && (
                            <img onClick={() => onAnswerClick(answer)} src={`${answer.image}?w=360`} alt="" className="answer-image" width="180" height="180" />
                        )}
                        <button onClick={() => onAnswerClick(answer)} className="secondary button">
                            <span>{answer.text}</span>
                        </button>
                    </div>
                ))}
            </div>
        </div>
    );
}

